import React, { createContext, useContext, useState, useEffect } from 'react';

const ScenarioContext = createContext({ scenario: 'realiste', setScenario: () => {} });
const STORAGE_KEY = 'ecolunch_scenario';

export function ScenarioProvider({ children }) {
  const [scenario, setScenarioState] = useState(() => {
    const stored = sessionStorage.getItem(STORAGE_KEY);
    return stored === 'minimum' ? 'minimum' : 'realiste';
  });

  const setScenario = (s) => {
    setScenarioState(s);
    sessionStorage.setItem(STORAGE_KEY, s);
  };

  useEffect(() => {
    sessionStorage.setItem(STORAGE_KEY, scenario);
  }, [scenario]);

  return (
    <ScenarioContext.Provider value={{ scenario, setScenario }}>
      {children}
    </ScenarioContext.Provider>
  );
}

export function useScenario() {
  return useContext(ScenarioContext);
}
